import { AsyncPipe, DatePipe, DecimalPipe } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { AssetClassOverviewFacade } from '@zero/asset-class-overview/domain';
import { commonRoutes } from 'constants/web-app-constants';

@Component({
  selector: 'etfs-call-money-alternatives',
  imports: [TranslocoPipe, AsyncPipe, DecimalPipe, RouterLink, DatePipe, NgbTooltipModule],
  templateUrl: './call-money-alternatives.component.html',
  styleUrl: './call-money-alternatives.component.scss',
})
export class CallMoneyAlternativesComponent implements OnInit {
  public readonly facade: AssetClassOverviewFacade = inject(AssetClassOverviewFacade);
  public readonly instrumentDetailsPage = commonRoutes.postlogin.instrument_detail;

  ngOnInit(): void {
    this.facade.loadCallMoneyAlternatives();
  }
}
